import { createThunkEffect } from "../../utilities/ActionUtility";
import * as CreditCardEffect from "./CreditCardEffect";

export const CREDIT_CARD_CUSTOMER = "CreditCardEffect.CREDIT_CARD_CUSTOMER";
export const CREDIT_CARD_CUSTOMER_FINISHED = "CreditCardEffect.CREDIT_CARD_CUSTOMER_FINISHED";

export function creditCardCustomer(customer) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, CREDIT_CARD_CUSTOMER, CreditCardEffect.paymentCustomer, customer);
    };
}

export const CREDIT_CARD_PAYMENT = "CreditCardEffect.CREDIT_CARD_PAYMENT";
export const CREDIT_CARD_PAYMENT_FINISHED = "CreditCardEffect.CREDIT_CARD_PAYMENT_FINISHED";

export function creditCardPayment(paymentInfo) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, CREDIT_CARD_PAYMENT, CreditCardEffect.paymentCharge, paymentInfo);
    };
}

export const PAYMENT_STATUS_CHECK = "CreditCardEffect.PAYMENT_STATUS_CHECK";
export const PAYMENT_STATUS_CHECK_FINISHED = "CreditCardEffect.PAYMENT_STATUS_CHECK_FINISHED";

export function checkStatusPayment(paymentId) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, PAYMENT_STATUS_CHECK, CreditCardEffect.checkStatusPayment, paymentId);
    };
}
